import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './store/store';
import ProgressiveLoader from './components/ProgressiveLoader';
import './index.css';
import App from './App';

// Remove loading screen when React is ready and stylesheets have loaded
// (avoids "Layout was forced before the page was fully loaded" / FOUC)
const removeLoadingScreen = () => {
  const doRemove = () => {
    const loadingScreen = document.querySelector('.loading-screen');
    if (loadingScreen) {
      loadingScreen.style.opacity = '0';
      loadingScreen.style.transition = 'opacity 0.3s ease';
      setTimeout(() => loadingScreen.remove(), 300);
    }
  };
  if (document.readyState === 'complete') {
    doRemove();
  } else {
    window.addEventListener('load', doRemove, { once: true });
  }
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Suspense fallback={<ProgressiveLoader onComplete={removeLoadingScreen} />}>
        <App />
      </Suspense>
    </Provider>
  </React.StrictMode>
);

